import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'

import { useAppSelector } from './hooks/redux'
import { Layout } from './components/Layout/Layout'
import { AuthGuard } from './components/AuthGuard'
import { LoginPage } from './pages/auth/LoginPage'
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { OrdersPage } from './pages/orders/OrdersPage'
import { EmployeesPage } from './pages/employees/EmployeesPage'
import { PayrollPage } from './pages/payroll/PayrollPage'
import { NotFoundPage } from './pages/NotFoundPage'
import UpdateNotification from './components/PWA/UpdateNotification'
import { triggerServiceWorkerUpdate } from './utils/pwaUtils'

function App() {
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  const handleUpdate = () => {
    triggerServiceWorkerUpdate()
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <UpdateNotification onUpdate={handleUpdate} />
      <Routes>
        {/* Public routes */}
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
          } 
        />
        
        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <AuthGuard>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/orders/*" element={<OrdersPage />} />
                  <Route path="/employees/*" element={<EmployeesPage />} />
                  <Route path="/payroll/*" element={<PayrollPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Layout>
            </AuthGuard>
          }
        />
      </Routes>
    </Box>
  )
}

export default App
